import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import DeleteModal from '@/components/core/DeleteModal.vue'
import DropdownMenu from '@/components/core/DropdownMenu.vue'
import DropdownMenuItem from '@/components/core/DropdownMenuItem.vue'
import LButton from '@/components/core/Button.vue'
import { useDeleteTransportation } from '@/composables/transportation'
import { useDeleteTransportationGroup } from '@/composables/transportation-group'
import { useSelectedTrip } from '@/composables/trip'
import { eventModule, tripModule } from '@/store'

interface Props {
  transportationId: string
  /** Group id when this transportation is part of a group, else undefined. */
  groupId?: string
  /** Disabled state from parent (e.g. while saving the form). */
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteActions',
  props: {
    transportationId: null,
    groupId: null,
    disabled: { type: Boolean }
  },
  emits: ["deleted"],
  setup(__props: any, { emit }: { emit: ({ (e: 'deleted'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  transportationId: string
  /** Group id when this transportation is part of a group, else undefined. */
  groupId?: string
  /** Disabled state from parent (e.g. while saving the form). */
  disabled?: boolean
};




const trip = useSelectedTrip()
const { mutate: deleteTransportationMutation } = useDeleteTransportation(
  trip.value._id,
)
const { mutate: deleteGroupMutation } = useDeleteTransportationGroup(
  trip.value._id,
)

const isDeleting = ref(false)
const isDropdownOpen = ref(false)

const isInGroup = () => !!props.groupId

function deleteThisTransportation() {
  isDeleting.value = true
  deleteTransportationMutation(props.transportationId, {
    onSuccess: async () => {
      await tripModule.fetch(trip.value._id)
      eventModule.newMessage('success.transportation.delete')
      emit('deleted')
    },
    onError: () => {
      eventModule.newError('error.transportation.delete')
    },
    onSettled: () => {
      isDeleting.value = false
    },
  })
}

function deleteWholeGroup() {
  if (!props.groupId) {
    return
  }
  isDeleting.value = true
  deleteGroupMutation(
    { groupId: props.groupId, keepSegments: false },
    {
      onSuccess: async () => {
        await tripModule.fetch(trip.value._id)
        eventModule.newMessage('success.transportation.delete')
        emit('deleted')
      },
      onError: () => {
        eventModule.newError('error.transportation.delete')
      },
      onSettled: () => {
        isDeleting.value = false
      },
    },
  )
}

return { __sfc: true,props, emit, trip, deleteTransportationMutation, deleteGroupMutation, isDeleting, isDropdownOpen, isInGroup, deleteThisTransportation, deleteWholeGroup, DeleteModal, DropdownMenu, DropdownMenuItem, LButton }
}

})